<template>
<div id="app" @scroll="check_header_fix()" :class="'rtl ' + (show_side_menu ? 'menu_open' : '')">
    <div id="side_menu" v-if="is_mobile()" style="text-align:center" role="navigation" aria-label="תפריט ניווט">

      <button class="side-menu__close-btn" @click="show_side_menu=false" aria-label="סגור תפריט">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>

		<button class="side-menu__search-btn" @click="open_search(); show_side_menu=false" aria-label="חיפוש">
        <span class="material-icons dp48" aria-hidden="true">search</span>
      </button>

		<!-- <ul class="sharing_list">
			<li id="fc_white"><a href="http://www.facebook.com/Hidabroot" target="_blank"></a></li>
			<li id="whatsapp_white"><a href="http://lp.vp4.me/b11r" target="_blank"></a></li>
			<li id="instagram_white"><a href="https://www.instagram.com/hidabroottv" target="_blank"></a></li>
			<li id="android_white"><a href="https://play.google.com/store/apps/details?id=net.linnovate.hidabroot" target="_blank"></a></li>
			<li id="itunes_white"><a href="https://itunes.apple.com/il/app/%D7%94%D7%99%D7%93%D7%91%D7%A8%D7%95%D7%AA/id1006747141?mt=8" target="_blank"></a></li>
		</ul> -->
	
		<ul>
            <li v-if="live.id > 0" class="btn_live live-badge"><router-link to="/live">שידור חי</router-link></li>
            <li v-for="menu_item in menu" :key="menu_item.id"  v-on:click.native="show_side_menu=false" ><router-link :to="'/'+ menu_item.link" v-on:click.native="show_side_menu=false"  :target="(menu_item.target != '' ? menu_item.target : '')" :style="(menu_item.color != '' ? 'color:#' + menu_item.color : '')"><span class="material-icons">{{menu_item.icon}}</span>{{ menu_item.name }}</router-link></li>
        </ul>

        <div id="mbl_user_menu">
            <!-- <ul>
                <li><router-link to='/user/profiles' v-on:click.native="show_side_menu=false">נהל פרופילים</router-link></li>
            </ul> -->
            <div style="border-bottom:1px solid #333;"></div>
            <ul>
                <li><router-link to='/user' v-on:click.native="show_side_menu=false">ניהול חשבון</router-link></li>
                <li><a @click="logout()">יציאה מ-TovTv</a></li>
                <!-- <li v-if="!user_data.is_active"  @click="show_payment = true;show_side_menu=false" style="color: #c12026;font-weight: 600;text-align: center;font-size: 18px;padding: 10px 0;">שדרוג למנוי פרימים</li> -->
            </ul>
        </div>

    </div>

    <main id="page-wrap" :class="(show_login || show_profile || $route.matched[0].props.default.header === false ? 'no_header' : '')">

        <div id="menu_hamburger"  v-if="is_mobile()" v-on:click="show_side_menu=!show_side_menu">
            <div id="nav-icon3"><span></span><span></span><span></span><span></span></div>
        </div>

        <TovHeader role="banner" @show_login="show_login=true" :class="header_class" v-if="!show_login && $route.matched[0].props.default.header !== false" :live="live" :user_data="user_data" :profile="profile" :menu="menu"  @open_search="open_search()" />
        <div id="page_content" v-if="general_loaded || $route.path === '/reset-password'">
            <LoginPage
          v-if="show_login"
          :initial_tab="login_initial_tab"
          :initial_step="login_initial_step"
          :initial_plan_id="login_initial_plan_id"
          @hide_login="onHideLogin()"
        />
            <Loginprofile v-if="show_profile && fromnews != 'news'" :user_data="user_data" :profile="profile" :menu="menu"  />
            <router-view v-if="!show_login && !show_profile" :key="$route.path" :user_data="user_data" :profile="profile" :country_code="country_code" @show_loader="loaded=false" @loaded="loaded=true" @open_pay="show_payment=true"></router-view>
        </div>
        <!-- <TovFooter v-if="$route.matched[0].props.default.footer !== false" :menu="menu_footer" /> -->
        <SearchPage v-show="show_search" @closesearch="show_search = false ;show_side_menu=false" ref="search_page_el" />
     
        <Pay v-if="show_payment" @close="show_payment=false" />
        <ResetPasswordOverlay v-if="showResetPassword" :token="resetPasswordToken" @close="showResetPassword=false" />
    </main>
 
   
    <div v-if="!loaded" id="app_loading">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>

</div>
</template> 

<script> 
import Loginprofile from './components/login_profile.vue'
import TovHeader from './components/header.vue'
import Pay from './components/pay.vue'
// import TovFooter from './components/footer.vue'
import SearchPage from './components/search.vue'
import LoginPage from './components/login.vue'
import ResetPasswordOverlay from './components/ResetPasswordOverlay.vue'


const isLocalDevHost = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
window.api_url = isLocalDevHost ? '/api/' : 'https://api.tov.tv/api/';

export default {
  name: 'app',
  components: {
    'Loginprofile': Loginprofile,
    'TovHeader': TovHeader,
    // 'TovFooter': TovFooter,
    'SearchPage': SearchPage,
    'LoginPage': LoginPage,
    'ResetPasswordOverlay': ResetPasswordOverlay,
    'Pay': Pay,

  },
  data(){
    return {
      show_payment: false,
      banner: false,
      show_search: false,
      header_class: '',
      user_data: {},
      profile: {},
      country_code: '',
      live: [],
      menu: [],
      menu_footer: [],
      show_side_menu: false,
      show_login: false,
      showResetPassword: false,
      resetPasswordToken: '',
      login_initial_tab: 'login',
      login_initial_step: 1,
      login_initial_plan_id: 0,
      user_exist: false,
      show_profile: false,
      loaded: false,
      general_loaded: false,
       user_token: localStorage.getItem('user_token'),
      fromnews: this.$route.params.news,
      //  prevRoute: this.$router.go(-1),
       prevRoute: `${this.$route.params.prevpage}?t=`,
    }
    
  },
    methods: {
    
        onHideLogin() {
          this.show_login = false;
          this.login_initial_tab = 'login';
          this.login_initial_step = 1;
          this.login_initial_plan_id = 0;
          this.$store.commit('close_signup');
        },
        check_header_fix(){
            // alert(4)
            if ( document.querySelector('#app').scrollTop > 68)
            {
                this.header_class = 'active'
            }
            else
            {
                this.header_class = ''
            }
        },

        open_search()
        {
            this.show_search = true;
            this.$refs['search_page_el'].reset();
        },
    },
    watch: {
      // Phase 1.3: lock body scroll while the side drawer is open (mirrors Modal.vue pattern).
      show_side_menu(val) {
        if (val) {
          document.body.classList.add('ui-drawer-open');
        } else {
          document.body.classList.remove('ui-drawer-open');
        }
      },
      // When any component commits open_signup to Vuex, App opens the login modal
      // in signup mode with the requested step and plan pre-selected.
      '$store.state.signup_open'(val) {
        if (val) {
          this.login_initial_tab = 'signup';
          this.login_initial_step = val.step || 1;
          this.login_initial_plan_id = val.plan_id || 0;
          this.show_login = true;
        }
      },
    },
    mounted(){
        let enable = document.createElement('script')
        enable.setAttribute('src', 'https://cdn.enable.co.il/licenses/enable-L10110gp640ny12e-1221-31350/init.js')
        document.head.appendChild(enable)
        window.app = this;
        if (!this.isNull(this.$route.query.login_token) && this.$route.query.login_token != ''){
            localStorage.setItem('user_token', this.$route.query.login_token);
            document.location = '/';
        }
        if (!this.isNull(this.$route.query.reset_token) && this.$route.query.reset_token != '') {
            this.resetPasswordToken = this.$route.query.reset_token;
            this.showResetPassword = true;
        }
        if (!this.isNull(this.$route.query.utm_source) && this.$route.query.utm_source != ''){
            localStorage.setItem('utm_source', this.$route.query.utm_source);
        }
        if (!this.isNull(this.$route.query.utm_medium) && this.$route.query.utm_medium != ''){
            localStorage.setItem('utm_medium', this.$route.query.utm_medium);
        }
        if (!this.isNull(this.$route.query.utm_campaign) && this.$route.query.utm_campaign != ''){
            localStorage.setItem('utm_campaign', this.$route.query.utm_campaign);
        }
        // categories 
        this.api_call({ url: 'general', data: { is_profile_valid: !this.isNull(window.sessionStorage.getItem('profile_id')) }, onComplete: (data) => {
        this.live = data.data.data.live
        this.user_data = data.data.data.user;
        this.country_code = data.data.data.country_code;
        this.menu = data.data.data.menu;
        this.menu_footer = data.data.data.footer;
        if (!this.isNull(data.data.data.profile)) this.profile = data.data.data.profile;

        this.$store.user = this.user_data;
        this.$store.state.profiles = this.user_data.profiles;
        this.$store.state.restrictions = data.data.data.restrictions;
        this.$store.state.restrictions_plans = data.data.data.restrictions_plans;
        this.$store.state.stickers = data.data.data.stickers;

        if (!(this.user_data.id > 0))
        {
            //this.$router.push("login");
            //this.show_login = true;
        }
        // If logged and not choosed profile yet
        else if(this.isNull(data.data.data.profile) || !(data.data.data.profile.id > 0))
        {
            this.show_profile = false;
            this.user_exist = true;

            if(this.fromnews === "news")
            {
                document.location = 'https://news.tov.tv/'+ this.prevRoute + this.user_token;
            }
        }
        // If logged and choose profile
        else 
        {
            if (this.$route.path.search('/set_up') === -1 && this.profile.has_perms == '1' && this.profile.new_setup == '0')
            { 
                document.location = '/set_up/' + this.profile.id
            }
            if(this.user_data.coupon == 20 && this.user_data.coupon_confirm == 0)
            {
                this.$fire({
                    title: "מנויים יקרים,מזמינים אתכם להמשיך להנות מהסרטים וסדרות מבוקרים לילדים מבוגרים ונוער. החל מהחודש השני מחיר המנוי יהיה 29.90. ניתן להתנתק בכל עת דרך האזור האישי",     
                    type: "success",
                    });
                    this.api_call({ url: 'coupon_confirm', data: { id : this.id}, onComplete: function(){ }});
            }
            if(this.fromnews === "news")
            {
                document.location = 'https://news.tov.tv/'+ this.prevRoute + this.user_token;
                }
        }
        
        

        this.loaded = true;
        this.general_loaded = true;
        this.banner = true;
    } } );

  }
}
</script>

<style lang="scss">
// Assistant font removed (Phase 0.3) — Sora + Heebo + JetBrains Mono loaded via <link> in public/index.html
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
#popupwrapper{
  position: fixed;inset: 0;z-index: 9999999;background: #0000009c;
  #image_pop{height: 50vw;
    width: 50vw;
    background-size: contain;
    position: absolute;
    background-repeat: no-repeat;
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
      #close{font-weight: 700;font-size: 30px;cursor: pointer;font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;}
    }
}
#search_results {
    height: calc(100vh - 150px);
    overflow-y: auto;
    padding: 20px;
}

/* Phase 1.4: live badge token */
.live-badge { color: var(--color-accent); font-size: 22px; font-weight: 800; text-align: center; }

/* Phase 1.3: body scroll lock when side drawer is open */
body.ui-drawer-open {
  overflow: hidden;
}

/* Phase 1.3: side drawer utility buttons */
.side-menu__close-btn,
.side-menu__search-btn {
  background: none;
  border: none;
  color: var(--color-text);
  cursor: pointer;
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
  padding: 0;
}
.side-menu__close-btn:focus-visible,
.side-menu__search-btn:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}
.side-menu__close-btn {
  display: block;
  margin-inline-start: auto; /* push to inline-end (visual left in RTL) */
  margin-bottom: 8px;
}
</style>
